// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"b810bca5","345":"a849d5af","461":"0a6d636c"}[chunkId] + ".chunk.css";
};